import { Box, Button, Grid, Modal, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/styles'
import React from 'react'
import { TextRegular } from '../../../../commonComponents/TextStyling'
import { ENV } from '../../../../ENV'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2
}

export default function ResendRTRmailModal ({ data }) {
  var { open, item, onClose } = data
  const theme = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 4,
            top: 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Typography
          id='modal-modal-description'
          sx={{ mt: 2 }}
          style={{ whiteSpace: 'pre-line' }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextRegular>
                The email is sent to {item?.candidateFirstName}{' '}
                {item?.candidateLastName} -{' '}
                <span style={{ color: theme.palette.primary.main }}>
                  {item?.candidateEmail}.
                </span>
              </TextRegular>
            </Grid>
            <Grid item xs={12}>
              <TextRegular>
                If your candidate is still unable to see the email, then remind
                him/her to check the spam or junk email folder.
              </TextRegular>
            </Grid>
            <Grid item xs={12}>
              <TextRegular>
                For further assistance, please contact us at {ENV.product_mail}{' '}
                or {ENV.product_contact}.
              </TextRegular>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <Button
                variant='contained'
                onClick={onClose}
                style={{ textTransform: 'none', marginTop: 10 }}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  )
}
